import { Skeleton } from "@/app/(site)/_components/Atoms/Skeleton"

export default function BasketProductCardSkeleton() {
    const number = 1
    return Array.from({ length: number }, (_, i) => (
        <div key={i} className="px-12 sm:px-16 md:px-24">
            <div className="flex gap-12">
                {/* Product image skeleton */}
                <Skeleton className="h-125 w-80 flex-shrink-0" />

                {/* Product details skeleton */}
                <div className="flex flex-1 flex-col gap-8">
                    {/* Product name */}
                    <div className="flex justify-between">
                        <Skeleton className="h-16 w-3/4" />
                        <Skeleton className="h-16 w-16" />
                    </div>
                    {/* Size/variant */}
                    <Skeleton className="h-12 w-1/2" />
                    {/* Price */}
                    <Skeleton className="h-16 w-1/3" />
                    {/* Quantity controls */}
                    <div className="mt-auto flex justify-between">
                        <div>
                            <Skeleton className="h-18 w-100" />
                        </div>
                        <div className="flex items-center gap-4">
                            <Skeleton className="h-16 w-16" />
                            <Skeleton className="h-12 w-12" />
                            <Skeleton className="h-16 w-16" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ))
}
